import React, { useRef } from "react";

import { DialogProps, DialogOverlay, DialogContent } from "@reach/dialog";
import Button, { ButtonProps, ButtonVariant } from "../Button";
import { ModalActions, ModalBody, ModalHeader } from ".";

export type ModalActionVariant = Exclude<
  ButtonVariant,
  "subtle" | "link" | "subtle-link"
>;

type ModalProps = {
  /**
   * Don't put the modal content into a DialogContent
   */
  fullScreen?: boolean;
} & DialogProps;

const Modal = React.forwardRef<HTMLDivElement, ModalProps>(
  ({ children, className, isOpen, fullScreen, ...props }, ref) => {
    return (
      <DialogOverlay isOpen={isOpen} className="z-10 font-sans">
        {fullScreen ? children : <DialogContent ref={ref} {...props} className={className}>{children}</DialogContent>}
      </DialogOverlay>
    );
  }
);

export default React.memo(Modal);
